<template>
  <div class="page_content module_microCompetency mc_content" aria-label="Create Micro Competency">
    <div class="row page-heading">
      <div class="col-8 input module_heading">
        <!-- Header -->
        <span class="module_icon ic24-microCompetency"></span>
          <h1 class="head_txt module_type_name ace_sec_hd" role="heading" aria-level="1">
            {{title}}
          </h1>
      </div>
      <div class="btn-container col-4">
        <!-- Menu -->
        <div class="pg_3x3_menu">
          <b-dropdown no-caret class="navigation-menu" id="mcNavMenu">
            <template slot="button-content">
              <span id="mcNav" class="module_icon ic22-menu3x3">
                <span class="sr-only">menu</span>
              </span>
            </template>
            <div class="links new_menu">
                <b-dropdown-item class="lnk_menu lnk_menu_footer" @click="edit(1)" role="link" aria-label="About">
                  <span class="lnk_txt">About</span>
                </b-dropdown-item>
                <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" aria-label="Content">
                  <span class="lnk_txt">Content</span>
                </b-dropdown-item>
                <b-dropdown-item class="lnk_menu lnk_menu_footer" @click="edit(3)" role="link" aria-label="Logic">
                  <span class="lnk_txt">Progress/Performance</span>
                </b-dropdown-item>
                <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" aria-label="Logic" :disabled="(!uuid)" @click="makeCopy(uuid)" >
                  <span class="lnk_txt">Make a Copy</span>
                </b-dropdown-item>

            </div>
          </b-dropdown>
        </div>
        <!-- End Menu -->
        <template v-if="!published">
          <button class="btn btn-primary" @click="curate(true)">curate</button>
        </template>
      </div>
    </div>
<!-- End Header -->
       <div class="row page_content_container">
          <div class="curate-content-section row">
            <div class="col-12">
            <div class="row">
              <div :key="uuid" class="col-4 toc_panel">
                  <b-list-group>
                      <div class="content-scroll-column">
                          <b-list-group v-if="items">
                                  <b-list-group-item class="topic-list-item" v-for="(subtopic, index) in items" :key="subtopic.uuid">
                                      <template  v-if="subtopic.action !== 'DELETE'">
                                        <div class="toc_row row_3 top-level-assets " v-bind:class="{ current_row: (currentEntityIndex==index) }" @click="currentEntityIndex=index" >
                                          <a href="javascript:void(0)">
                                            <span class="ic_container">
                                              <span v-if="subtopic.fileType === 'assessment'" class="icon icon-assessment"></span>
                                              <span v-if="subtopic.fileType === 'video'" class="icon icon-video"></span>
                                              <span v-if="subtopic.fileType === 'pdf'" class="icon icon-file-pdf"></span>
                                              <span v-if="subtopic.fileType === 'csv'" class="icon icon-csvFile"></span>
                                              <span v-if="subtopic.fileType === 'txt'" class="icon icon-file-text"></span>
                                              <span v-if="subtopic.fileType === 'mp4' || subtopic.fileType === 'mp3'" class="icon icon-video"></span>
                                              <span v-if="subtopic.fileType === 'zip'" class="icon icon-file-zip"></span>
                                              <span v-if="subtopic.fileType === 'scorm'" class="icon icon-scorm"></span>
                                              <span v-if="subtopic.fileType === 'doc' || subtopic.fileType === 'docx'" class="icon icon-file-word"></span>
                                              <span v-if="subtopic.fileType === 'xlsx' || subtopic.fileType === 'xls'" class="icon icon-file-excel"></span>
                                              <span v-if="subtopic.fileType === 'pptx' || subtopic.fileType === 'ppt'" class="icon icon-pagePPT"></span>
                                              <span v-if="subtopic.fileType === 'html'" class="icon icon-pageURL"></span>
                                              <span v-if="subtopic.fileType === 'externalurl'" class="icon icon-pageURL"></span>
                                              <span v-if="subtopic.fileType === 'jpg' || subtopic.fileType === 'jpeg' || subtopic.fileType === 'png' || subtopic.fileType === 'gif'" class="icon icon-image"></span>
                                              <span v-if="subtopic.fileType === 'other'" class="icon icon-asset"></span>
                                            </span>
                                            <span class="lnk_txt">{{subtopic.title}}</span>
                                          </a>
                                        </div>
                                  </template>
                              </b-list-group-item>
                    </b-list-group>
                  </div>
                  </b-list-group>
              </div>

              <div class="col-8 curate-right-section datatable">
                <!-- Nav -->
                <div class="entity-nav">
		          <div class="float-left entity-title-section">
		            <span v-if="entity.fileType === 'assessment'" class="icon icon-assessment"></span>
		            <span v-if="entity.fileType === 'video'" class="icon icon-video"></span>
		            <span v-if="entity.fileType === 'pdf'" class="icon icon-file-pdf"></span>
		            <span v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="icon icon-file-word"></span>
		            <span v-if="entity.fileType === 'xlsx'" class="icon icon-file-excel"></span>
		            <span v-if="entity.fileType === 'html'" class="icon icon-pageURL"></span>
		            <span v-if="entity.fileType === 'externalurl'" class="icon icon-pageURL"></span>
		            <span v-if="entity.fileType === 'other'" class="icon icon-pageURL"></span>
		            <span v-if="entity.fileType === 'scorm'" class="icon icon-scorm"></span>
		            <span v-if="entity.fileType === 'zip'" class="icon icon-file-zip"></span>
		            <span v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="icon icon-image"></span>
		            <h3 class="entity-title float-left ace_sec_hd">{{entity.title}} </h3>
		          </div>
		          <div class="float-right float-right pt-3 pr-2">
		            <b-button class="btn button-primary next" :disabled="(currentEntityIndex==0)" @click="currentEntityIndex=currentEntityIndex-1"
		            aria-label="previous">
		            	<span class="float-left"> < </span>
		            	<span class="btn_txt">prev</span>
		            </b-button>
		            <b-button class="btn button-primary next"  :disabled="(currentEntityIndex==topics.length-1)" @click="currentEntityIndex=currentEntityIndex
		            +1" aria-label="next">
		            	<span class="float-right"> > </span>
		            	<span class="btn_txt">next</span>
		            </b-button>
					</div>
		        </div>
		        <!-- End Nav -->
		        <div>
		        <template v-if="!previewResource && !loadLaunchAssessmentWidget">
              		<div class="entity-content-section">
              			<span class="desc-heading ace_sec_hd">Description</span>
              			<span class="asset-description ace_sec_txt" v-html="entity.description"></span>
              		</div>
              		<div>
              		   <div v-if="entity.type === 'ASSESSMENT'">
		                <b-button variant="primary" size="lg" class="btn_lg" aria-label="Preview " @click="showAssessmentPreview" >Preview</b-button>
                    <template v-if="!published">
                    <customize-assessment :mcId="uuid" :entityType="entity.type" :entityUuid="entity.uuid" :sessionId="'id'+Date.now()"></customize-assessment>
                    </template>

              		   </div>
		              <div v-else>
		                <b-button variant="primary" size="lg" class="btn_lg" aria-label="Preview Resource" @click="showPreviewResource" >Preview </b-button>
		              </div>
              		</div>
              	</template>
              	</div>
<!-- Start Preview-->
					<div v-if="previewResource" class="entity-learn-content">
						<template v-if="entity.type === 'RICH_HTML'">
			                  <rich-html-launch-assessment :resource-id="entity.uuid" :html="entity.htmlBody" :course-id="entity.uuid" :container-class="'rich-html-container-learn'"></rich-html-launch-assessment>
			             </template>
			             <template v-else>

					      <div v-if="entity.fileType === 'pdf' || entity.fileType === 'gif' || entity.fileType === 'png' || entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'doc' || entity.fileType === 'docx' || entity.fileType === 'ppt' || entity.fileType === 'pptx' || entity.fileType === 'html' || entity.fileType === 'other' || entity.fileType === 'externalurl' || entity.fileType === 'mp3' || entity.fileType === 'csv' || entity.fileType === 'zip'" class="pdf-container pdf-iframe-container-div">
					        <iframe class="iframe_container2 dd" v-if="showIframe && (entity.fileType !== 'pdf')" aria-label="content container frame" id="contentIframe" width="100%" height="415" :src="getFinalUrl(entity)" frameborder="0"></iframe>

					        <iframe class="iframe_container2" v-if="showIframe && entity.fileType === 'pdf' && !pdfDivEnabled " aria-label="content container frame" id="contentIframe" width="100%" height="415" :src="getFinalUrl(entity)" frameborder="0">
					        <html><head></head><body><div>Test_Div</div></body></html>
					        </iframe>

					        <div id="pdf-viewer" v-if="showIframe && pdfDivEnabled &&  entity.fileType === 'pdf'"></div>
					      </div>

					      <div v-else-if="entity.fileType === 'mp4'" class="video_container">
					        <video controls>
					          <source :src="getFinalUrl(entity)" type="video/mp4">
					          Your browser does not support the video tag.
					        </video>
					      </div>
<!--
					      <div v-else-if="entity.fileType === 'scorm'" class="container pdf-container">
					        <iframe width="100%" height="415" aria-label="content container frame" :src="scormUrl" frameborder="0"></iframe>
					      </div>
-->
					      <div v-else-if="entity.fileType === 'video'" class="container">
					        <p class="pull-right lnk_open_new_tab_container" v-if="showLoadingMessage"><a target="_blank" :href="getFinalUrl(entity)" class="lnk_open_new_tab"><span class="icon-new-tab"></span> Open this resource in a new tab</a></p>
					        <template v-if="entity.categoryId === '00011'">
					          <youtube v-if="!showLoadingMessage" :video-id="entity.yt" :player-vars="{ rel:0 }"  ref="youtube" style="width: 100%; height: 100%;"></youtube>
					        </template>
					        <template v-else>
					          <iframe :src="getFinalUrl(entity)" frameborder="0"></iframe>
					        </template>
					      </div>
					     </template>
					</div>
<!-- End Preview -->
				<div v-if="loadLaunchAssessmentWidget" class="assessment-container">
					<template >
                        <div  id="learnosity_assess"></div>
                    </template>
            	</div>

              </div>
            </div>

            </div>
          </div>

        </div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
/* eslint no-labels: ["error", { "allowLoop": true }] */
import '../../../assets/module/css/course/courseCurate.min.css'
import Vue from 'vue'
import draggable from 'vuedraggable'
import { mapState, mapActions } from 'vuex'
import { getSimpleLibraryFilter } from '../../search/searchUtils.js'
import RichHtmlLaunchAssessment from '../../assessment/components/RichHtmlLaunchAssessment'
import CustomizeAssessment from '../../course/components/customize-assessment/CustomizeAssessment.vue'
import Vuelidate from 'vuelidate'
import {required, url, numeric, minValue} from 'vuelidate/lib/validators'
Vue.use(Vuelidate)

var EntityData = function (id, title, type, contentFileType, fileType) {
  this.id = id
  this.uuid = undefined
  this.uri = undefined
  this.title = title
  this.type = type
  this.action = undefined
  this.thumbnail = undefined
  this.isDataRendered = false
  this.isStudentEditable = false
  this.children = []
  this.contentFileType = contentFileType
  this.fileType = fileType
  this.html = undefined
  this.originUuid = undefined
}
var specialDocuments = {
  'csv': 'CSV',
  'dif': 'Data Interchange Format',
  'msword': 'Microsoft Word',
  'doc': 'Microsoft Word',
  'docm': 'Macro Enabled Document',
  'docx': 'Microsoft Word',
  'dot': 'Word 97-2003 Template',
  'dotm': 'Macro Enabled Template',
  'dotx': 'Microsoft Word Template',
  'mht': 'Single Web Page',
  'mhtml': 'Single page html',
  'odt': 'Open Document',
  'pdf': 'PDF',
  'pm': 'Formated Text',
  'ppt': 'Power Point',
  'pptx': 'Power Point',
  'prn': 'PRN',
  'rtf': 'Rich Text Format',
  'slk': 'SYLK',
  'thmx': 'THMX',
  'wps': 'Works 6-9 Document',
  'xls': 'Excel',
  'xlsb': 'Excel Workbook',
  'xlsx': 'Excel',
  'xlsm': 'Excel Macro Enabled Workbook',
  'xlt': 'Excel Template',
  'xps': 'XPS',
  'php': 'PHP',
  'c': 'C'
}
export default {
  name: 'mc-curation',
  props: ['uuid'],
  components: {
    draggable,
    RichHtmlLaunchAssessment,
    CustomizeAssessment
  },
  data: () => {
    return {
      title: 'Test',
      published: true,
      items: [],
      topics:[],
      showIframe: true,
      pdfDivEnabled: false,
      previewResource: false,
	  currentEntityIndex:0,
	  loadLaunchAssessmentWidget:false,
      entity:{},
      entityId: 0,
      entityType: {
        TOPIC: 'LearningTopic',
        ASSET: 'LearningContent'
      },
      userId: '',
      userRole: '',
      libraryList: '',
      indexes: [
        {
          text: 'Asset [0]',
          value: 'LearningContent',
          checked: true
        }
      ],
      indexesSelected: ['LearningContent'],
      allIndexes: ['learningcontent'],
      assetType: [],
      assetTypeSelected: [],
      isFirstTimeLoad: true
    }
  },

  validations: {
    contentUri: {
      required,
      url
    },
    assessmentMaxAttempt: {
      required,
      numeric,
      minVal: minValue(1)
    }
  },

  mounted () {
  this.selectedComptency = this.uuid
    this.loadMicroCompetencyDetail(this.uuid).then((res) => {
      this.title = res.title
      this.published = res.published
    })
    this.loadMicroCompetencyAssets(this.uuid).then(res => {
      this.topics = JSON.parse(res.plan)
      this.entity = this.topics[this.currentEntityIndex]
      this.renderTopicPlan(this.topics, this.items)
      this.userId = localStorage.getItem('userid')
      this.userRole = localStorage.getItem('userrole')
    })
  },

  methods: {
    ...mapActions([
      'loadMicroCompetencyDetail',
      'loadMicroCompetencyAssets',
      'launchAssessment',
      'createCopy'
    ]),
    curate (){
      return this.$router.push({ name: 'microCompetencyCurate', params: { uuid: this.uuid } })
    },
    showAssessmentPreview(){
        this.previewResource = false
    	this.loadLaunchAssessmentWidget = true
      	this.initLaunchAssessment()
    },
    showPreviewResource(){
    	this.previewResource = true
    	this.loadLaunchAssessmentWidget = false
    },
    makeCopy(mcId){
        this.createCopy(mcId).then(res => {
          if(res.uuid){
            setTimeout(() => {
              return this.$router.push({ name: 'microCompetencyList' })
            }, 1000)
            this.showMessage('Successfully created copy of '+res.title)
          }else{
            this.showMessage('Error created copy of '+this.model.title)
          }
        })
    },
    showMessage (message, mType) {
      this.$notify({
        group: 'notify',
        type: mType,
        title: '',
        text: message
      })
    },    
    renderTopicPlan (plan, data, action) {
      if (plan) {
        $.each(plan, (index, item) => {
          var newEntity = this.createNewEntity(item)
          if (action) {
            newEntity.action = action
          }
          data.push(newEntity)
        })
      }
    },
    edit (opValue){
      return this.$router.push({ name: 'microCompetencyEdit', params: { uuid: this.uuid , opstate: opValue} })
    },

    initLaunchAssessment () {
      this.launchAssessment({uuid: this.entity.uuid, courseId: this.entity.uuid, sessionId: 'id'+Date.now()}).then(res => {
        if (res) {
          const signedRequest = JSON.parse(res.signedRequest)
          var self = this
          self.itemsApp = LearnosityItems.init(signedRequest, {
            'readyListener': function () {
              self.bindReadyListener()
            },
            'errorListener': function (event) {
              console.log('error: ', event)
            }
          })
        }
      })
    },

    bindReadyListener () {
      this.getMinAndMaxScoreForActiveQuestion()
      var assessApp = this.itemsApp.assessApp()
      assessApp.on('item:load', () => {
        this.getMinAndMaxScoreForActiveQuestion()
      })
    },

    getMinAndMaxScoreForActiveQuestion () {
      $.each(this.itemsApp.getItems(), (index, item) => {
        if (item.active) {
          let maxScore = 0
          $.each(item.questions, (i, question) => {
            if (question.metadata.valid_response_count === 0) {
              maxScore += (question.validation && question.validation.max_score) ? question.validation.max_score : 0
            }
          })
          $('.lrn-min-max-score').remove()
          if (maxScore > 0) {
            $('.lrn-top-left-region').append('<div class="lrn-min-max-score">Min Score: 0 and Max Score: ' + maxScore + '</div>')
          }
        }
      })
    },
   getFinalUrl(entity){
      this.handleSpecialDocuments(entity)
   		return entity.iframeUrl ? entity.iframeUrl:entity.uri
   },
   createNewEntity (item, action) {
      if (item) {
        var type = this.entityType.TOPIC
        if (item.resourceType === 'learningcontent' || item.objectType === 'LearningContent' || item.resourceType === 'lmscontent' || item.objectType === 'lmscontent' || item.type === 'LearningContent') {
          type = this.entityType.ASSET
        }
        var id = this.entityId++
        var entity = new EntityData(id, item.title, type, item.contentFileType, item.fileType)
        if (item.uuid) {
          entity.uuid = item.uuid
        }
        if (item.externalId) {
          entity.externalId = item.externalId
        }
        if (item.importedExportedSynced) {
          entity.importedExportedSynced = item.importedExportedSynced
        }
        if (item.uri) {
          entity.uri = item.uri
        }
        if (item.thumbnail) {
          entity.thumbnail = item.thumbnail
        }
        if (item.embedlyHtml) {
          entity.html = item.embedlyHtml
        }
        if (item.htmlBody) {
          entity.htmlBody = item.htmlBody
        }
        if (item.description) {
          entity.description = item.description
        }
        if (item.originUuid) {
          entity.originUuid = item.originUuid
        }
        if (item.rootOriginUuid) {
          entity.rootOriginUuid = item.rootOriginUuid
        }
        if (item.ancestor) {
          entity.ancestor = item.ancestor
        }
        if (item.owningLibraryId) {
          entity.owningLibraryId = item.owningLibraryId
        }
        if (item.studentEditable) {
          entity.isStudentEditable = item.studentEditable
        }
        entity.customType = item.type
        if (item.fileSize) {
          entity.fileSize = item.fileSize
        }
        if (item.appliedTagMap) {
          var appliedTagMap = item.appliedTagMap
          entity.appliedTagMap = appliedTagMap
        }
        if (item.localPractice) {
          entity.localPractice = item.localPractice
        }
        if (item.maxAttempt) {
          entity.maxAttempt = item.maxAttempt
        }
        if (item.creationTime) {
          entity.creationTime = item.creationTime
        }
        if (item.whiteListed) {
          entity.whiteListed = item.whiteListed
        }
        if (item.blackListed) {
          entity.blackListed = item.blackListed
        }
        if (action) {
          entity.action = action
        }
        this.handleSpecialDocuments(entity)
        return entity
      }
    },
    isUriContainsSpecialCharacter (uri) {
      return true
    },
    handleSpecialDocuments (content) {
      if (specialDocuments[content.fileType]) {
        var uri = content.uri
        var versionIdWithValue = ''
        if (uri.indexOf('?versionId=') !== -1) {
          versionIdWithValue = uri.substring(uri.indexOf('?versionId='), uri.length)
          uri = uri.substring(0, uri.indexOf('?versionId='))
        }
        if (this.isUriContainsSpecialCharacter(uri)) {
          var modifiedUri = uri.substring(0, uri.lastIndexOf('/'))
          modifiedUri = modifiedUri.concat('/').concat(encodeURIComponent(uri.substring(uri.lastIndexOf('/') + 1, uri.length)))
          let encodedUri = encodeURIComponent(modifiedUri)
          encodedUri += versionIdWithValue
          if (content.fileType === 'pdf' || content.fileType === 'docx' || content.fileType === 'doc' || content.fileType === 'docx' || content.fileType === 'ppt' || content.fileType === 'pptx' || content.fileType === 'csv' ) {
            content.iframeUrl = 'https://drive.google.com/viewerng/viewer?url=' + encodedUri + '&embedded=true'
          } else if (content.fileType === 'html' || content.fileType === 'other') {
            content.iframeUrl = encodedUri
          }
          return (content.fileType === 'pdf' && encodedUri.indexOf('s3-us-west-2.amazonaws.com') !== -1) ? decodeURIComponent(encodedUri) : ('https://drive.google.com/viewerng/viewer?url=' + encodedUri + '&embedded=true')
        }
        let encodedUri = encodeURIComponent(uri)
        encodedUri += versionIdWithValue
        if (content.fileType === 'pdf' || content.fileType === 'doc' || content.fileType === 'docx' || content.fileType === 'ppt' || content.fileType === 'pptx') {
          content.iframeUrl = 'https://drive.google.com/viewerng/viewer?url=' + encodedUri + '&embedded=true'
        } else if (content.fileType === 'html' || content.fileType === 'other') {
          content.iframeUrl = encodedUri
        }
        return (content.fileType === 'pdf' && encodedUri.indexOf('s3-us-west-2.amazonaws.com') !== -1) ? decodeURIComponent(encodedUri) : ('https://drive.google.com/viewerng/viewer?url=' + encodedUri + '&embedded=true')
      }
      content.iframeUrl = content.uri
      return content.uri
    },


  },

  computed: {
    ...mapState({
    }),
  },
  watch: {
    currentEntityIndex (newValue) {
    	var el1 = document.getElementById("learnosity_assess")
    	if(el1){
    		el1.innerHTML = ""
    		el1.className=""
    	}
    	this.loadLaunchAssessmentWidget = false
    	this.previewResource = false
    	this.entity = this.topics[newValue]
    }
  }

}
</script>

<style scoped>
.mc_content .curate-content-section .toc_panel {
  padding-left: 10px !important;
}
.mc_content .curate-content-section .toc_panel .list-group-item .toc_row.row_3.top-level-assets {
  padding-left: 15px;
}
.mc_content .curate-content-section .toc_panel .list-group-item .toc_row.row_3 > a {
  grid-template-columns: 24px minmax(0, 1fr);
}
.mc_content .curate-content-section .toc_panel .list-group-item .toc_row.row_3 > a > .lnk_txt {
  min-width: 0;
  margin: 0;
}
.mc_content .entity-nav .entity-title-section {
	width: calc(100% - 277px);
	display: flex;
	align-items: center;
	gap: 12px;
	height: 63px;
}
.mc_content .entity-nav .entity-title-section > .icon,
.mc_content .entity-nav .entity-title-section > .entity-title {
	margin: 0;
}
.current_row {
	background: #e6f0d5;
}
.content-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    border: dashed;
    background: #ebebeb;
}
.inputTitle {
    width: 92%;
    height: 15px;
}

.title {
    font-size: 17px
}

.close-button {
  position: absolute;
  right: 18px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  justify-content: center;
  font-size: 13px;
  padding: 0px;
  top: 13px;
}
.container {
  width: calc(100% - 60px);
  max-width: calc(100% - 60px);
  margin-left: 30px;
  height: 98%;
}
.container iframe {
  width: 90% !important;
  margin-left: 5%;
  height: 95%;
}
.content-section {
  float: left;
    width: 100%;
    margin-top: 5px;
    margin-left: 6px;
    margin-bottom: 13px;
}

.collapsed > .collapsed,
:not(.collapsed) > .expand {
  display: none;
}

.table-content-header, .table-content-header:hover {
  border-bottom: solid 1px rgb(217, 217, 217) !important;
  background: rgb(249, 249, 249) !important;
}

.invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
}

</style>



// WEBPACK FOOTER //
// src/app/microCompetency/components/MicroCompetencyPlayer.vue